/* eslint-disable jsx-a11y/img-redundant-alt */
import DefaultImg from 'Assets/images/commons/default-img.jpg';
import RxImg from 'Assets/images/commons/rx.svg';
import { CurrencyLabel } from 'Modules/Currency';
import Space from 'Modules/Space';
import { number, shape } from 'prop-types';
import React from 'react';

import css from './MarketplaceItem.less';

const MarketplaceItem = ({ product, quantity }) => {
  const { name, priceIncludeTax, productImages, regularPrice } = product;
  const productImage = productImages?.length ? productImages[0]?.imageInfo?.thumbPath : DefaultImg;
  const isRequiredConsult = product?.productType?.requiredConsult;

  return (
    <Space
      size={12}
      width="100%"
      direction="horizontal"
      justify="space-between"
      alignItems="center">
      <Space size={16} direction="horizontal">
        <img src={productImage} alt="name" width={80} height={80} style={{ borderRadius: 4 }} />
        <Space width="100%" size={12}>
          <Space size={12} width="100%" direction="horizontal" fontSize="16px">
            {isRequiredConsult && <img width={20} height={20} src={RxImg} alt="rx image" />}
            {name}
          </Space>
          <Space direction="horizontal">
            <strong className={css.price}>
              S$ <CurrencyLabel value={priceIncludeTax} />
            </strong>
            {regularPrice > 0 && (
              <strong className={css.regularPrice}>
                S$ <CurrencyLabel value={regularPrice} />
              </strong>
            )}
          </Space>
        </Space>
      </Space>
      <span>x{quantity}</span>
    </Space>
  );
};

export default MarketplaceItem;

MarketplaceItem.propTypes = {
  product: shape({}).isRequired,
  quantity: number.isRequired,
};
